import axios from 'axios';
import { messageNotification, smallNotification } from '@shared/services/gf.notification.service';
import HelperS from '@/shared-modules/services/helper.service';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
import store from '@/store/index';

export default {
  createProject(data) {
    return axios
      .post(`/api/project`, data, {
        formName: FORM_NAME_ENUMS.PROJECT_CREATE_FORM
      })
      .then((res) => res?.data)
      .catch((err) => {
        messageNotification('danger', {
          message:
            err.response.status == 403
              ? err.response.data.detail
              : 'Проверьте корректность заполнения формы!',
          hasTimeline: false
        });
        throw err;
      });
  },
  createMirror(data) {
    return axios
      .post(`/api/project/create-mirror`, data, {
        formName: FORM_NAME_ENUMS.MIRROR_CREATE_FORM
      })
      .then((res) => res?.data)
      .catch((err) => {
        messageNotification('danger', {
          message: 'Проверьте корректность заполнения формы!',
          hasTimeline: false
        });
        throw err;
      });
  },
  importBase(data) {
    return axios
      .post(`/api/project/import-base`, data, {
        formName: FORM_NAME_ENUMS.IMPORT_BASE_FORM
      })
      .then((res) => res?.data)
      .catch((err) => {
        messageNotification('danger', {
          message: 'Проверьте корректность заполнения формы!',
          hasTimeline: false
        });
        throw err;
      });
  },
  importProject(data) {
    return axios
      .post('/api/project/import', data, {
        formName: FORM_NAME_ENUMS.PROJECT_IMPORT_FORM,
        headers: 'multipart/form-data'
      })
      .then((res) => res?.data)
      .catch((err) => {
        if (err.response.data.status === 400) {
          smallNotification('danger', { title: err.response.data.detail });
        } else {
          smallNotification('danger', { title: 'Произошла ошибка' });
        }
        throw err;
      });
  },
  createFork(userAlias, projectAlias, data) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/fork`, data, {
        formName: FORM_NAME_ENUMS.FORK_CREATE_FORM
      })
      .then((res) => res?.data)
      .catch((err) => {
        messageNotification('danger', {
          message: 'Проверьте корректность заполнения формы!',
          hasTimeline: false
        });
        throw err;
      });
  },
  getGitIgnoreTemplates() {
    return axios.get(`/api/project/create/gitignores`).then((res) => {
      store.dispatch('setGitIgnoreTemplates', res.data);
      return res.data;
    });
  },
  getOwnedGitlabProjects(data) {
    return axios
      .get(`/api/project/migration/owned-projects`, {
        params: {
          hostUrl: data.hostUrl,
          accessToken: data.accessToken,
          ...HelperS.getRealPagination(data || {})
        }
      })
      .then((res) => {
        store.dispatch('setGitlabOwnedProjects', res.data);
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err.response.data.detail;
      });
  },
  getOwnedGitlabProjectsPage(data) {
    return axios
      .get(`/api/project/migration/owned-projects-page`, {
        params: {
          hostUrl: data.hostUrl,
          accessToken: data.accessToken,
          ...HelperS.getRealPagination(data || {})
        }
      })
      .then((res) => {
        store.dispatch('setGitlabOwnedProjects', res.data);
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err.response.data.detail;
      });
  },
  getImportedGitlabProjects(params) {
    return axios
      .get(`/api/project/migration/imported-projects`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setGitlabImportedProjects', res.data);
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err;
      });
  },

  importGitlabProjects(form) {
    return axios
      .post(
        `/api/project/migration/import`,
        {
          projectsToImport: form
        },
        {
          formName: FORM_NAME_ENUMS.MASS_IMPORT_FORM
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err;
      });
  },
  importGitlabProjectsForAllPages(form) {
    return axios
      .post('/api/project/migration/import-all', form, {
        formName: FORM_NAME_ENUMS.MASS_IMPORT_FORM
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err;
      });
  },
  restartGitlabProjectImport(importId) {
    return axios
      .put(`/api/project/migration/restart/${importId}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err;
      });
  }
};
